export default function HowItWorks() {
  const steps = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'Atendimento',
      description: 'Nossos canais de atendimento oficiais são via WhatsApp ou Direct no Instagram. Vamos realizar um atendimento personalizado e entender o que você está buscando, tirar suas dúvidas e até te ajudar a escolher o produto ideal para seu uso.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Valores',
      description: 'Vamos te passar as cotações dos produtos que você está procurando e as formas de pagamento disponíveis.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Contrato',
      description: 'Depois que você decidir seu produto, vamos para o próximo passo: Assinatura do contrato! Todos os pedidos têm contrato com validade jurídica aqui na Steel para te dar segurança.'
    },
    {
      icon: 'ri-secure-payment-line',
      title: 'Pagamento',
      description: 'O pagamento pode ser realizado das seguintes formas: PIX/TED (condições especiais), cartão de crédito em até 12 vezes pelo Mercado Pago, e entrada à vista + parcelamento no cartão de crédito em até 12x.'
    },
    {
      icon: 'ri-time-line',
      title: 'Controlar a Ansiedade 😅',
      description: 'Encomenda fechada! Agora é tudo com a gente. Vamos importar o seu produto com total segurança e vamos te atualizando durante todo o processo. Assim que ele chegar em nossas mãos, você vai receber uma foto dele antes de fazermos o envio.'
    },
    {
      icon: 'ri-gift-line',
      title: 'Chegou seu Produto 🎉',
      description: 'Seu produto chega em suas mãos, seguro e protegido, com nota fiscal. Todos envios são feitos com seguro para o máximo de segurança. E o frete é grátis.'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-br from-black via-gray-900 to-black border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Como Funciona? É Simples!
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Em 6 passos fáceis, você recebe seu produto dos EUA sem estresse. Estamos com você do início ao fim! 💪
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all group">
              <div className="flex items-start gap-4 mb-4">
                <div className="flex-shrink-0 w-12 h-12 bg-indigo-900/50 rounded-xl flex items-center justify-center border border-indigo-700/30 group-hover:bg-indigo-900/70 transition-all">
                  <i className={`${step.icon} text-2xl text-indigo-400`}></i>
                </div>
                <div className="flex-shrink-0 w-8 h-8 bg-white/10 rounded-full flex items-center justify-center">
                  <span className="text-indigo-400 font-bold text-sm">{index + 1}</span>
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
              <p className="text-gray-300 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
